import { Group, TextInput, Title } from '@mantine/core';
// import { useFileSelect } from './use-file-select';
import { Container, ContentWrapper, InputWrapper } from './styles';
import { InfoTooltip } from '@morph-mapper/ui';
import { useEffect, useState } from 'react';
import { getOrders } from '@/api';
import { useUpdateOrderGet } from './use-update-order-get';

export interface UpdateOrderGetProps {
  children: (progress: () => void, disabled?: boolean) => JSX.Element;
}

export const UpdateOrderGet = ({ children }: UpdateOrderGetProps) => {
  const {
    progressSetup,
    disableNext,
    correctFound,
    bookingNumber,
    setBookingNumber,
  } = useUpdateOrderGet();

  return (
    <>
      <Container>
        <ContentWrapper>
          <Title order={3} fw={500}>
            Retrieve Orders
          </Title>
          <InputWrapper>
            <Group position="apart">
              Booking Number:
              <InfoTooltip
                label={`Example Booking Numbers: orderFC100519589670 \n FC100519589671`}
              />
            </Group>
            {correctFound ? (
              <TextInput
                placeholder=""
                error="Valid order found"
                value={bookingNumber}
                styles={(theme) => ({
                  input: {
                    '&[data-invalid]': {
                      color: 'black',
                      borderColor: theme.colors.green[6],
                    },
                  },
                  error: {
                    color: theme.colors.green[6],
                  },
                })}
                onChange={(e) => setBookingNumber(e.target.value)}
              />
            ) : (
              <TextInput
                placeholder=""
                error={correctFound == null ? null : 'Invalid order'}
                value={bookingNumber}
                onChange={(e) => setBookingNumber(e.target.value)}
              />
            )}
          </InputWrapper>
        </ContentWrapper>
      </Container>

      {children(progressSetup, disableNext)}
    </>
  );
};
